<template>
  <div class="container">
    <vue-tel-input
      mode="international"
      @input="updateValue"
      class="phone-input"
      defaultCountry="us"
      :onlyCountries="countries"
      :placeholder="placeholder"
      maxLen="15"
      inputClasses="phone-input-container"
    />
    <div v-if="error !== ''" class="error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      countries: ["us", "vn"],
    };
  },
  props: {
    type: {
      type: String,
      default: "text",
    },
    error: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
  },
  methods: {
    updateValue: function (value, obj) {
      this.$emit("input", value, obj);
    },
  },
};
</script>

<style lang="scss">
.vue-tel-input:focus-within {
  box-shadow: none;
}
.vti__input {
  background-color: #f9f7f1;
}
.vti__dropdown {
  background-color: #f9f7f1;
  &:hover {
    background-color: #f9f7f1;
  }
}
::placeholder {
  color: #696969;
  font-weight: 600;
}
.container {
  margin-bottom: 20px;
  background-color: #f9f7f1;
}
.phone-input-container {
  background-color: #f9f7f1 !important;
}
.phone-input {
  border-radius: 5px;
  height: 50px;
  border: 1px solid #eeeeee !important;
  font-size: 16px;
  font-weight: 600;
}
.error {
  color: red;
  margin-top: 8px;
  font-weight: 600;
  text-align: left;
}
</style>